var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"manage-workgroup-title title-notab"},[_vm._v(" Organization Chart > จัดการกลุ่มงาน ")])
}
var staticRenderFns = []

export { render, staticRenderFns }